import { activityHistoryFiltersSlice } from "../filter/slice";

export const { setSearchString } = activityHistoryFiltersSlice.actions;
